import { Chip as MuiChip } from '@mui/material';
import Icon from '@platform-ui-common/components/Icon/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import Color from '@platform-ui-common/utilities/Color.js';
import { IconProps, IconType } from '../Icon/Icon.types.js';

export enum ChipSize {
  S = 'small',
  M = 'medium',
}

export interface ChipProps {
  icon?: IconType;
  iconColor?: Color;
  label: string;
  size?: ChipSize;
  iconSize?: IconProps['size'];
  variant?: 'default' | 'white';
}

export default function Chip({
  label,
  icon,
  iconColor,
  size = ChipSize.M,
  iconSize = 'MD',
  variant = 'default',
}: ChipProps): JSX.Element {
  return (
    <MuiChip
      size={size}
      icon={icon ? <Icon type={icon} size={iconSize} color={iconColor} /> : null}
      label={
        <Typography variant={size === ChipSize.S ? 'fieldLabel' : 'body'} color={Color.Text}>
          {label}
        </Typography>
      }
      {...(variant === 'white' && { sx: { backgroundColor: Color.White } })}
    />
  );
}
